import { UTILITIES } from "constants/action-types";
import { IFlowV2, IDataFlow } from "containers/management/management-types";
import type { IStore } from "reducers";
import type { IAction, IRequestAction, IRequestDataAction } from "epics/base-epic";
import { IFetchBrandsDataPayload } from "../brands-data-actions";
import { stringify } from "querystring";

export const fetchBrands = (payload: IFetchBrandsDataPayload): IAction<IRequestAction> => ({
    type: UTILITIES.DATAFLOW_MANAGEMENT.BRANDS.FETCH.START,
    payload: { url: `/brands?${stringify({ fields: payload?.fields })}` },
});

export const fetchBrandDetailed = (brandId: string): IAction<IRequestAction> => ({
    type: UTILITIES.DATAFLOW_MANAGEMENT.BRAND_DETAILED.FETCH.START,
    payload: { url: `/brand/${brandId}` },
});

export const fetchDataflow = (brandId: string): IAction<IRequestAction> => ({
    type: UTILITIES.DATAFLOW_MANAGEMENT.FLOW.FETCH.START,
    payload: { url: `/brand/dataflows/${brandId}` },
});

export const resetFlowDate = (brandId: string, restrictToast?: boolean, cb?: Function): IAction<IRequestAction> => {
    const meta = {
        restrictToast: false,
        cb: null,
    };
    if (restrictToast) {
        meta.restrictToast = restrictToast;
    }
    if (cb) {
        meta.cb = cb;
    }
    return {
        type: UTILITIES.DATAFLOW_MANAGEMENT.FLOW.RESET,
        payload: { url: `/brand/dataflows/${brandId}/reset` },
        meta,
    };
};

export const saveDataflow = (body: IDataFlow): IAction<IRequestDataAction<IDataFlow>> => ({
    type: UTILITIES.DATAFLOW_MANAGEMENT.FLOW.SAVE,
    payload: { url: `/brand/dataflows/${body.brand}`, body },
});

export const updateDataflow = (dataflow: IDataFlow) => (dispatch, getState: () => IStore) => {
    dispatch({
        type: UTILITIES.DATAFLOW_MANAGEMENT.FLOW.UPDATE,
        payload: { ...getState().dataflow.flow.payload, dataflow },
    });
};

export const updateCompanyFlowV2 = (
    brandId: string,
    body: Partial<IFlowV2>
): IAction<IRequestDataAction<Partial<IFlowV2>>> => ({
    type: UTILITIES.DATAFLOW_MANAGEMENT.FLOW_V2.UPDATE,
    payload: { url: `/brand/dataflows/${brandId}/flow-v2`, body },
});

export const fetchBrandDataflow = (): IAction<IRequestAction> => ({
    type: UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.FETCH.START,
    payload: { url: "/brand/dataflow" },
});

export const resetBrandDataFlow = (cb?: Function): IAction<IRequestAction> => {
    const meta = {
        cb: null,
    };
    if (cb) {
        meta.cb = cb;
    }
    return {
        type: UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.RESET,
        payload: { url: "/brand/dataflow/reprocess" },
        meta,
    };
};

export const saveBrandDataflow = (body: IDataFlow, cb?: Function): IAction<IRequestDataAction<IDataFlow>> => {
    const meta = {
        cb: null,
    };
    if (cb) {
        meta.cb = cb;
    }
    return {
        type: UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.SAVE,
        payload: { url: "/brand/dataflow", body },
        meta,
    };
};

export const updateBrandDataflow = (dataflow: IDataFlow) => (dispatch, getState: () => IStore) => {
    dispatch({
        type: UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.UPDATE,
        payload: { ...getState().dataflow.flow.payload, dataflow },
    });
};
